
import mongoose from 'mongoose'
import RoleSchema from './schemas/RoleSchema'

const RoleModel = mongoose.model("role", RoleSchema, "role")

export default RoleModel